export enum Entitlement {
  QuestionBank = 'question-bank',
}

export type EntitlementList = Entitlement[];

export type EntitlementMode = 'all' | 'any';
export const DEFAULT_ENTITLEMENT_MODE: EntitlementMode = 'all';
